import math from '@/sui/tools/math'
import bar from '@/sui/tools/chart/bar'
import { classicBoxAndViolinPlot,
  limitText,
  repColors
} from '@/sui/tools/chart/boxPlot'
import doughnut from '@/sui/tools/chart/doughnut'

import o4table from '@/sui/data/caracteristics/observa4/table'
import reatable from '@/sui/data/caracteristics/reaInfADI/table'
import neotable from '@/sui/data/caracteristics/neoInfADI/table'
import diatable from '@/sui/data/caracteristics/diaInfADI/table'
import inftable from '@/sui/data/caracteristics/infections/table'
import {
  discValues
} from '@/sui/data/caracteristics/tools'

import assert from '@/sui/tools/assert'
import ice from '@/sui/tools/ice'

const toPlot = {
  text: function (f, d) {
    return {}
  },

  mm: function (f, d) {
    function build () {
      return () => {
        assert(f != null)
        const points = [...f.values]
        const stats = math.statistics(points)
        assert(d != null)
        const title = `${d.t}`
        return classicBoxAndViolinPlot(
          title,
          points,
          stats,
          d
        )
      }
    }

    return {
      boxplot: build(),
      violin: build()
    }
  },

  rep: function (f, d) {
    function build (isBarChart) {
      return () => {
        const labels = []
        const data = []
        const colors = []
        assert(d != null)
        const availableValues = d.v
        assert(f != null)
        assert(availableValues != null)

        const repc = repColors(availableValues)
        for (let i = 0; i < availableValues.length; i++) {
          const r = availableValues[i]
          const index = r.index != null ? r.index : r.code
          const v = f.values[index]
          if (v == null) {
            continue
          }

          labels.push(limitText(r.value))
          data.push(v)
          colors.push(repc[i])
        }

        const dataset = [
          {
            fill: true,
            backgroundColor: colors,
            data: data
          }
        ]

        if (isBarChart) {
          return bar.classic(
            'bar',
            d.t,
            dataset,
            labels
          )
        }

        return doughnut.classic(
          'rep-doug',
          d.t,
          dataset,
          labels
        )
      }
    }

    return {
      doughnut: build(false),
      bar: build(true)
    }
  }
}

const toValues = {
  mm: function (f, d, allValues) {
    const s = f.values.slice().sort((a, b) => a - b)
    return [
      {
        label: 'Effectif',
        count: f.total
      },
      {
        label: 'Moyenne',
        count: (f.sum / f.total).toFixed(1)
      },
      {
        label: 'Médiane',
        count: math.median(s).toFixed(1)
      }
    ]
  },

  text: function (f, d, allValues) {
    const result = [
      {
        label: 'Effectif',
        count: f.total
      }
    ]

    for (let key in f.values) {
      let label = `«${key}»`
      if (d.v != null) {
        const entry = d.v.find(elt => `${elt.code}` === key)
        if (entry) {
          label = entry.value
        }
      }

      result.push(
        {
          label: label,
          count: f.values[key]
        }
      )
    }
    return result
  },

  rep: function (f, d, allValues) {
    const result = [
      {
        label: 'Effectif',
        count: f.total
      }
    ]

    if (process.env.VUE_APP_SPIADI_DEBUG === '1') {
      const keys = Object.keys(f.values)
      const errors = []
      for (let j = 0; j !== keys.length; ++j) {
        const s = keys[j]
        if (d.v == null || d.v.find == null) {
          errors.push(`Error: find is null ${s} (${d.t})`)
          continue
        }

        if (d.v.find(
          r =>
            `${r.index}` === s ||
              (`${r.code}`.toUpperCase() === s.toUpperCase())) == null
        ) {
          errors.push(
            `Error: missing config value for code ${s} (${d.t})`
          )
        }
      }
      assert.equals(errors.length, 0, errors.join('\n'))
    }

    let total = 0
    const formatedValues = []
    const values = d.v

    for (let i = 0; i < values.length; i++) {
      const r = values[i]
      const index = r.index != null ? r.index : r.code
      const v = f.values[index]
      const vFinal = allValues && v == null ? 0 : v

      if (vFinal == null) {
        continue
      }

      const neutral = d.n != null && d.n === index
      if (!neutral) {
        total += vFinal
      }
      formatedValues.push({ l: r.value, v: vFinal, p: !(f.hidep || neutral) })
    }

    for (let i = 0; i < formatedValues.length; i++) {
      const v = formatedValues[i]
      const r = {
        label: v.l,
        count: v.v
      }

      if (v.p) {
        const p = (100 * v.v / total).toFixed(1)
        r.percentage = `${p}%`
      }
      result.push(r)
    }
    return result
  }
}

function flatten (tables, source) {
  const result = []
  for (let i = 0; i < tables.length; i++) {
    const c = tables[i]
    const line = {
      title: c.title,
      key: c.key,
      open: c.open,
      displayAllValues: c.displayAllValues,
      lines: []
    }

    const content = c.list
    for (let j = 0; j < content.length; j++) {
      const l = content[j]
      const v = source[l.f]
      if (v != null && v.total > 0) {
        const key = l.h ? `headline-${l.f}` : l.f
        const values = l.h ? [] : toValues[v.type](v, l, c.displayAllValues)
        line.lines.push(
          {
            title: l.t,
            key: key,
            values: values,
            heading: l.h,
            plot: toPlot[v.type](v, l)
          }
        )
      }
    }

    if (line.lines.length > 0) {
      result.push(line)
    }
  }
  return ice.freeze(result)
}

function flattenInfectionsDistribution (source, estb, complete) {
  return flatten(inftable.all(source.year, estb, complete), source)
}

function flattenObserva4 (source, regions, year) {
  const table = o4table(regions, year)
  return flatten(table, source)
}

function flattenReaInfADI (source, estb, complete) {
  const tables = reatable(estb, source.year, complete)
  return flatten(tables, source)
}

function flattenNeoInfADI (source, estb) {
  const tables = neotable(estb, source.year)
  return flatten(tables, source)
}

function flattenDiaInfADI (source, estb) {
  const tables = diatable(estb, source.year)
  return flatten(tables, source)
}

export default {
  flatten: {
    infections: flattenInfectionsDistribution,
    observa4: flattenObserva4,
    reaInfADI: flattenReaInfADI,
    neoInfADI: flattenNeoInfADI,
    diaInfADI: flattenDiaInfADI,
    flatten: flatten
  },

  toPlot,
  cfg: {
    discipline: { f: `discipline`, t: `Discipline`, v: discValues }
  }
}
